import React, { useState, useRef } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Input } from "antd";
import CustomButton from "../../../components/Elements/Buttons/CustomButtons";
import { API_URLS } from "../../../api/apiUrls";
import { postApi } from "../../../api/api_instance";
import PopupCard from "../../../components/Cards/PopupCard/PopupCard";
import { ReactComponent as UploadButtonIcon } from "../../../assets/svgs/uploadButtonIcon.svg";

const CreateReportTypeDialog = ({
  onOpen,
  onClose,
  onSuccess,
  onSave,
  onError,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [pdf, setPdf] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    name: "",
    description: "",
    pdf: "",
  });
  const [popup, setPopup] = useState({
    visible: false,
    type: "success",
    title: "",
    message: "",
  });
  const fileInputRef = useRef(null);

  // const showPopup = (type, title, message) => {
  //   setPopup({ visible: true, type, title, message });
  // };
const showPopup = (type, title, message) => {
  setPopup({ visible: true, type, title, message });
  const duration = type === 'success' ? 3000 : 3000; // success 2 sec, others 3 sec
  setTimeout(() => {
    closePopup();
  }, duration);
};
  const closePopup = () => {
    setPopup({ visible: false, type: "success", title: "", message: "" });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.type !== "application/pdf") {
        setErrorMessage((prev) => ({ ...prev, pdf: "Only PDF files are allowed" }));
        showPopup("error", "Invalid File", "Please select a PDF file only");
        return;
      }
      setPdf(file);
      setErrorMessage((prev) => ({ ...prev, pdf: "" }));
    }
  };

  const handleSave = async () => {
    let isValid = true;
    const errors = { name: "", description: "", pdf: "" };

    if (!name.trim()) {
      errors.name = "Name is required";
      isValid = false;
    }
    if (!description.trim()) {
      errors.description = "Description is required";
      isValid = false;
    }
    if (!pdf) {
      errors.pdf = "PDF file is required";
      isValid = false;
    }

    setErrorMessage(errors);
    
    if (!isValid) {
      showPopup("warning", "Validation Error", "Please fill all required fields");
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("description", description);
      formData.append("pdf", pdf);

      const response = await postApi({
        apiUrl: API_URLS.ADD_REPORT_TYPE,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.success) {
        showPopup("success", "Success", "Report Type created successfully!");
        setTimeout(() => {
          closePopup();
          handleCancel();
          if (onSave) onSave();
          if (onSuccess) onSuccess();
        }, 3000);
      } else {
        showPopup(
          "error",
          "Error",
          response.message || "Failed to create Report Type"
        );
        if (onError)
          onError(response.message || "Failed to create Report Type");
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Something went wrong.";
      showPopup("error", "Error", errorMsg);
      if (onError) onError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setName("");
    setDescription("");
    setPdf(null);
    setErrorMessage({ name: "", description: "", pdf: "" });
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    // closePopup();
    // onClose();
     setTimeout(() => {
          closePopup();
         onClose();
         
        }, 3000);
  };

  return (
    <>
      <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="600px">
        <div>
          <h3 className="text-xl font-bold text-[#06513D]">
            Add New Report Type
          </h3>
        </div>

        <div className="rounded-xl border mt-5 px-12">
       

          <div className="flex flex-col mt-2 gap-6">
            <div>
              <Input
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  if (e.target.value.trim()) {
                    setErrorMessage((prev) => ({ ...prev, name: "" }));
                  }
                }}
                placeholder="Name"
                className="h-14 rounded-lg"
              />
              
            </div>

            <div>
              <Input.TextArea
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value.trim()) {
                    setErrorMessage((prev) => ({ ...prev, description: "" }));
                  }
                }}
                placeholder="Description"
                className="rounded-lg"
                rows={6}
              />
              
            </div>

            <div>
              <div
                className="bg-gray-100 border border-gray-300 rounded-md flex justify-between items-center cursor-pointer"
                onClick={() => fileInputRef.current?.click()}
              >
                <div className="text-gray-500 p-3">
                  {pdf ? pdf.name : "Please select your file here"}
                </div>
                <button
                  type="button"
                  className="bg-[#06513D] text-white px-10 rounded-r py-3 h-full"
                  onClick={(e) => {
                    e.stopPropagation();
                    fileInputRef.current?.click();
                  }}
                >
                  <UploadButtonIcon />
                </button>
                <input
                  ref={fileInputRef}
                  type="file"
                  accept=".pdf"
                  className="hidden"
                  onChange={handleFileChange}
                />
              </div>
             
            </div>
          </div>

          <div className="flex justify-center gap-6 p-5">
            <CustomButton
              buttonType="button"
              variant="cancel"
              buttonText="Cancel"
              onClick={handleCancel}
              className="text-base font-normal h-[50px] w-[160px]"
              disabled={loading}
            />

            <CustomButton
              buttonType="button"
              variant="ok"
              buttonText={loading ? "Saving..." : "Save"}
              onClick={handleSave}
              className="text-base font-normal h-[50px] w-[160px]"
              disabled={loading}
            />
          </div>
        </div>
      </DailogBox>

      {/* PopupCard Overlay */}
      {popup.visible && (
        <div className="fixed inset-0 bg-black/30 z-[9999] flex items-center justify-center">
          <PopupCard
            type={popup.type}
            title={popup.title}
            message={popup.message}
          />
        </div>
      )}
    </>
  );
};

export default CreateReportTypeDialog;